import { Children, cloneElement, isValidElement, useEffect, useRef, useState } from 'react'
import type { ReactNode } from 'react'
import styled from 'styled-components'

// import mapStyle from './mapStyle'
import { useDeepCompareEffectForMaps } from './useDeepCompareEffectForMaps'

const StyledMap = styled.div`
  height: 100%;
  width: 100%;
`

interface MapProps extends google.maps.MapOptions {
  center: google.maps.LatLngLiteral
  children?: ReactNode
  onClick?: (e: google.maps.MapMouseEvent) => void
  onIdle?: (map: google.maps.Map) => void
  onBoundsChanged?: (map: google.maps.Map) => void
  onZoomChanged?: (zoom: number) => void
}

interface MapWithCustomData extends google.maps.Map {
  dragInProgress?: boolean
}

const Map = ({
  center,
  children,
  onBoundsChanged,
  onClick,
  onIdle,
  onZoomChanged,
  ...options
}: MapProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [map, setMap] = useState<MapWithCustomData>()

  useEffect(() => {
    if (ref.current && map === undefined) {
      const googleMap = new window.google.maps.Map(ref.current, {
        zoom: 8,
        center: {
          lat: center.lat,
          lng: center.lng,
        },
        // styles: mapStyle,
      })
      setMap(googleMap)

      googleMap.data.setStyle(feature => {
        const color = feature.getProperty('fillColor')
        return {
          fillColor: color,
          fillOpacity: 0.35,
          strokeWeight: 1,
        }
      })
    }
  }, [ref, map])

  useDeepCompareEffectForMaps(() => {
    if (map) {
      map.setOptions(options)
    }
  }, [map, options])

  useEffect(() => {
    map?.panTo(center)
  }, [center.lat, center.lng])

  const [initialized, setInitialized] = useState(false)
  useEffect(() => {
    if (map && !initialized) {
      ;['click', 'idle', 'bounds_changed', 'zoom_changed'].forEach(eventName =>
        google.maps.event.clearListeners(map, eventName),
      )

      if (onClick) {
        map.addListener('click', onClick)
      }

      if (onIdle) {
        // map.addListener('idle', () => onIdle(map))
      }

      if (onBoundsChanged) {
        // @ts-ignore
        map.addListener('idle', () => {
          onBoundsChanged(map)
        })
      }

      if (onZoomChanged) {
        map.addListener('zoom_changed', () => {
          const newZoom = map.getZoom()
          if (newZoom) onZoomChanged(newZoom)
        })
      }

      setInitialized(true)
    }
  }, [map, initialized])

  return (
    <>
      <StyledMap
        id="google-map"
        ref={ref}
      />
      {Children.map(children, child => {
        if (isValidElement(child)) {
          // @ts-ignore
          return cloneElement(child, { map })
        }
      })}
    </>
  )
}

export default Map
